import { Container } from '@repo/ui'
import { ContactForm } from './components/form'
import { ContactInfo } from './components/info'

export function ContactPage() {
  return (
    <main className="relative overflow-hidden">
      <div className="absolute inset-0 bg-background" />
      <div className="absolute inset-x-0 top-0 h-96 web-route-wash opacity-90" />
      <div className="pointer-events-none absolute inset-0 web-bg-grid opacity-20" />

      <Container size="wide" className="relative py-24 md:py-32">
        <div className="grid gap-12 lg:grid-cols-[0.88fr_1.12fr] lg:items-start">
          <div className="lg:sticky lg:top-28">
            <p className="mb-4 text-[0.68rem] font-semibold uppercase tracking-[0.24em] text-primary/80">
              Contact Zippity
            </p>
            <h1 className="max-w-[11ch] text-5xl font-normal tracking-tight md:text-7xl">
              Talk through your route.
            </h1>
            <p className="mt-7 max-w-xl text-lg leading-8 text-muted-foreground md:text-xl md:leading-9">
              Have a scheduling question, setup concern, or route problem you want to pressure-test?
              Send the details and we will help you figure out whether Zippity fits the way your
              week actually runs.
            </p>

            <div className="mt-10 grid gap-0 border-y border-border/70">
              {[
                ['Setup help', 'Calendar, service area, start and end locations.'],
                ['Route questions', 'Whether your current schedule can be made easier to run.'],
                ['Partnerships', 'Working with mobile operators, booking tools, or vertical SaaS.'],
              ].map(([title, body]) => (
                <div key={title} className="border-b border-border/70 py-5 last:border-b-0">
                  <p className="font-medium text-foreground">{title}</p>
                  <p className="mt-1 text-sm leading-6 text-muted-foreground">{body}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid gap-6 xl:grid-cols-[1.08fr_0.92fr]">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </Container>
    </main>
  )
}
